import { appCdnUrl, assetFilePath } from '../../utilities'
import { Image }                    from '../Image'

interface ThreadSingleAttachment
{
  attachment: any,
  classes?: string
  handleAttachment: () => any
}

export default function CommunityForumThreadSingleAttachment( props: ThreadSingleAttachment ): JSX.Element {
  const { attachment, classes, handleAttachment } = props

  return (
    <div
      className={ classes ?? 'media-wrapper flex items-center justify-center bg-black cursor-pointer rounded-2xl' }
      onClick={ handleAttachment }
    >
      <Image
        src={ appCdnUrl + attachment.url }
        alt={ attachment.name }
        defaultSrc={ assetFilePath( attachment.file_ext ) }
        klass="max-w-full max-h-full object-contain"
      />
    </div>
  )
}
